<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Performance Inputs</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (airflowSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">Airflow:</label>
            <input type="number" class="configurationRatingTextInput" #airflowInput
              [value]="airflowSelection.Value"
              (change)="selectionChanged(airflowSelection, airflowInput.value || '0')">
            <label class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits() }}</label>
          </span>
        }
        @if (staticPressureTypeSelection && staticPressureValueSelection) {
          <span class="configurationInput">
            <select class="configurationInputField staticPressureInputField" #staticPressureTypeInput
              (change)="selectionChanged(staticPressureTypeSelection, staticPressureTypeInput.value.toString())"
              [value]="staticPressureTypeSelection.Value">
              @for (allowable of staticPressureTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                            [selected]="staticPressureTypeSelection.Value != undefined && staticPressureTypeSelection.Value != null
                                     && staticPressureTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
            <input type="number" class="configurationRatingTextInput" #staticPressureValueInput
              [value]="staticPressureValueSelection.Value" step="0.01"
              (change)="selectionChanged(staticPressureValueSelection, staticPressureValueInput.value || '0')">
            <label class="configurationRatingUnitLabel">{{ getPressureMeasurementUnits() }}</label>
          </span>
        }
        @if (altitudeSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">Altitude:</label>
            <input type="number" class="configurationRatingTextInput" #altitudeInput
              [value]="altitudeSelection.Value"
              (change)="selectionChanged(altitudeSelection, altitudeInput.value)">
            <label class="configurationRatingUnitLabel">{{ getDistanceMeasurementUnits() }}</label>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (inputTypeSelection) {
          <span class="configurationInput">
            <label class="configurationInputLabel">Input Type:</label>
            <select class="configurationInputField" #inputTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(inputTypeSelection.Name)"
              (change)="inputTypeChanged(inputTypeInput.value)" [value]="inputTypeSelection.Value">
              @for (allowable of inputTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                            [selected]="inputTypeSelection.Value != undefined && inputTypeSelection.Value != null
                                     && inputTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <app-performance-input [engineKey]="engineKey()" [selectionEntities]="selectionEntities()" [isMetric]="isMetric"
        (valueChanged)="performanceValueChanged()">
      </app-performance-input>
      @if (ratingResponseError) {
        <div class="ratingError">
          {{ ratingResponseError }}
        </div>
      }
    </div>
  }
</div>
